<app-profile-form
  [userToEdit]="collabUser"
  [canEdit]="canEdit"
  [displayEditButton]="isCurrentUserNotaire"
  (loadUser)="loadCollabUser()"
></app-profile-form>
